var _style, _symbol, _symbol2, _path, _g, _path2, _path3, _g2, _filter, _feBlend, _mask, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _g4, _g5, _g6, _g7, _g8, _circle, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g9, _g10, _g11, _g12, _g13, _g14, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g15, _g16, _g17, _path109, _path110, _path111, _path112, _g18, _g19, _rect, _g20, _g21, _g22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmV3PlatinePlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 243.7 219.4",
    style: {
      enableBackground: "new 0 0 243.7 219.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#FBF2A8;}\n    .st1{fill:#EBE7E7;}\n    .st2{fill:#D9D8D7;}\n    .st3{fill:#F1E9A1;}\n    .st4{fill:#FFD600;}\n    .st5{fill:#E022A6;}\n    .st6{fill:#1E1E21;}\n    .st7{opacity:0.9;}\n    .st8{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n    .st9{filter:url(#Adobe_OpacityMaskFilter);}\n    .st10{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-miterlimit:10;}\n    .st11{stroke:#000000;stroke-miterlimit:10;}\n    .st12{mask:url(#SVGID_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n    .st13{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n    .st14{fill-rule:evenodd;clip-rule:evenodd;fill:#4E4E51;}\n    .st15{fill:#FFD700;}\n    .st16{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n    .st17{fill:#C2C5C6;}\n    .st18{fill:#C77C11;}\n    .st19{fill:#B4B5B5;}\n    .st20{fill:#C43B3A;}\n    .st21{fill:#D3CCA5;}\n    .st22{fill:#E6E2C2;}\n    .st23{fill:#B6B083;}\n    .st24{fill:#EAE8E7;}\n    .st25{fill:#D2CAA4;}\n    .st26{fill:#E5E0C0;}\n    .st27{fill:#D6D2D1;}\n    .st28{fill:#181716;}\n    .st29{opacity:0.9;fill:#FFFFFF;}\n    .st30{fill:#C8CCCF;}\n    .st31{fill:#59595A;}\n    .st32{fill:#FFFFFF;}\n    .st33{fill:#6B6D6D;}\n    .st34{fill-rule:evenodd;clip-rule:evenodd;fill:#1E1E21;}\n    .st35{fill:#3AA5C6;}\n    .st36{display:none;}\n    .st37{display:inline;fill:#6B6D6D;}\n    .st38{fill:none;}\n    .st39{fill:#54BDC2;}\n    .redFill{fill:#C43B3A;}\n    .ledOn{filter: url(#ledglow); fill: rgb(255, 85, 85);}\n\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "Calliope_x5F_3_x5F_LED",
    viewBox: "-1.1 -2.4 2.3 4.8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: -1.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 0 0)",
    className: "st0",
    width: 2.3,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: -2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1.506985e-04 -3.5627)",
    className: "st1",
    width: 2.3,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: -2.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1.506985e-04 -4.4003)",
    className: "st2",
    width: 2.3,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1.512592e-04 4.3999)",
    className: "st2",
    width: 2.3,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 1.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1.512592e-04 3.5623)",
    className: "st1",
    width: 2.3,
    height: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 0,
    cy: 0,
    r: 0.1
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "Calliope_x5F_3_x5F_Small_x5F_LED",
    viewBox: "-0.7 -1.4 1.4 2.8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: -0.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4.715784e-05 1.083041e-04)",
    className: "st0",
    width: 1.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: -1.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -4.702561e-05 -2.0956)",
    className: "st1",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: -1.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -4.702561e-05 -2.5883)",
    className: "st2",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: 1.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -4.737604e-05 2.5883)",
    className: "st2",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: 0.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -4.737604e-05 2.0956)",
    className: "st1",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 0,
    cy: 0,
    r: 0.1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Platine",
    className: "st6",
    d: "M234.1,122.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.1-0.5,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0.1     c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0-0.6,0.1-0.8,0.1c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9,0c-7.2,0-13-5.8-13-13c0-2.2,0.5-4.2,1.5-6     c0.6-1.2,1.4-2.3,2.3-3.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.2,0.5-0.4,0.7-0.5     c0.2-0.2,0.5-0.3,0.7-0.5c0.2-0.1,0.4-0.3,0.7-0.4c0.2-0.1,0.5-0.2,0.7-0.4s0.5-0.2,0.7-0.3c0.4-0.2,0.8-0.3,1.2-0.4     c0.2,0,0.3-0.1,0.5-0.1c0.3-0.1,0.6-0.1,1-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.5,0c0.6,0,1.2,0,1.8,0.1     c0.1,0,0.3,0,0.4,0.1c0.7,0.1,1.4,0.3,2,0.5c-31.5-12.7-50.3-45.3-45.4-79c-0.1,0.3-0.1,0.6-0.2,0.9c-0.2,0.7-0.4,1.3-0.7,1.9     c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.3,0.4-0.5,0.6     c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.3-0.6,0.4     c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.5,0.3-0.8,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-1.1,0.4-2.3,0.7-3.5,0.8     c-0.4,0-0.8,0.1-1.2,0.1c-2.6,0-5.1-0.8-7.1-2.1c-1.4-0.9-2.7-2.2-3.6-3.5c-1.4-2.1-2.3-4.6-2.3-7.4c0-0.2,0-0.5,0-0.7     c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.2,0.1-0.5,0.2-0.8c0.1-0.3,0.2-0.6,0.3-1     c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.4c0.1-0.3,0.2-0.5,0.4-0.8c0.1-0.2,0.3-0.5,0.4-0.7c0.4-0.7,0.9-1.4,1.5-2     c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.4,0.6-0.5c0,0,0,0,0,0     c0.2-0.2,0.4-0.3,0.7-0.5c0.2-0.1,0.4-0.3,0.6-0.4c-0.2,0.1-0.4,0.2-0.5,0.3c-0.3,0.2-0.6,0.4-0.9,0.6c-9.7,7.7-20.9,13.2-32.8,16.1     v19c0,0.3-0.2,0.6-0.4,0.7c-0.4,0.2-0.9,0.1-1.2-0.3c-0.2-0.3-0.4-0.4-0.7-0.4h-21.5c-0.3,0-0.6,0.2-0.7,0.4     c-0.2,0.3-0.4,0.4-0.7,0.4c-0.5,0-0.9-0.4-0.9-0.8v-19c-11.4-2.8-22.1-7.9-31.4-15c0.2,0.2,0.4,0.4,0.6,0.7c0,0,0,0,0,0     c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.2,0.2,0.4,0.3,0.6c0.6,1.1,1,2.3,1.2,3.5     c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.5,0.1,0.7c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0.1v0c0,0.2,0,0.5,0,0.8c0,7.2-5.8,13.1-13.1,13.1     c-0.2,0-0.5,0-0.7,0c-0.5,0-1-0.1-1.6-0.2c-0.3-0.1-0.6-0.1-0.9-0.2c-0.4-0.1-0.8-0.2-1.2-0.4c-0.3-0.1-0.7-0.2-1-0.4     c-0.3-0.1-0.6-0.3-0.9-0.4c0,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.6-0.3-0.8-0.5c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2-0.2-0.4-0.3-0.6-0.5     c-0.2-0.2-0.4-0.4-0.6-0.5c-0.6-0.6-1.1-1.2-1.6-1.9c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.2-0.2-0.3-0.3-0.5     c-0.1-0.2-0.2-0.4-0.3-0.5c-0.2-0.4-0.4-0.8-0.5-1.3c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.3-0.1-0.6-0.2-0.8     c0-0.1,0-0.2-0.1-0.4c0,0,0-0.1,0-0.1c0,0.1,0,0.1,0,0.2C59.5,51.9,41,84.6,9.6,97.5c0.8-0.2,1.6-0.4,2.4-0.5c0.2,0,0.4,0,0.6-0.1     c0.2,0,0.4,0,0.7,0c3.6,0,6.8,1.4,9.2,3.8c2.4,2.4,3.9,5.7,3.9,9.3c0,7.2-5.8,13.1-13.1,13.1c-0.4,0-0.9,0-1.3-0.1     c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.4-0.1-0.8-0.3-1.2-0.4c0.1,0,0.2,0.1,0.3,0.1     c31.4,12.3,50.3,44.3,46.2,77.6c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.3-0.6     c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1c0.1-0.3,0.3-0.5,0.5-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0,0,0.1-0.1,0.1-0.1     c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.3,0.5-0.6,0.8-0.9c0,0,0,0,0.1-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.3,0.4-0.4h0     c0.2-0.2,0.3-0.3,0.5-0.4c0.2-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.3-0.3,0.5-0.4c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.3     c0.7-0.5,1.4-0.8,2.1-1.2c0.4-0.2,0.9-0.4,1.4-0.5c0.6-0.2,1.3-0.3,1.9-0.4c0.2,0,0.5-0.1,0.7-0.1c0.4,0,0.9-0.1,1.4-0.1     c0.4,0,0.9,0,1.3,0.1c0.2,0,0.4,0,0.5,0.1c0.2,0,0.4,0,0.5,0.1c0.2,0,0.3,0.1,0.5,0.1c0.8,0.2,1.7,0.5,2.4,0.8     c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.2,0.6,0.3,0.9,0.5c0.3,0.2,0.6,0.4,0.8,0.6c0.3,0.2,0.6,0.5,0.9,0.7c0.2,0.2,0.4,0.4,0.6,0.6     c0,0,0,0,0,0c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0.2,0.3,0.5,0.5,0.7     c0.2,0.3,0.4,0.6,0.6,1c0.1,0.2,0.3,0.5,0.4,0.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0.3,0.2,0.5,0.3,0.8c0,0,0,0.1,0,0.1     c0.1,0.3,0.2,0.6,0.3,0.9l-1.8-10.4c-0.2-1.3,0.4-2.6,1.7-3.1l2-0.4c1.5-0.3,3,0.8,3.3,2.3l2,11.4c0.2,1.2,1.4,2.1,2.6,1.8     c0,0,0,0,0,0l13.4-2.4l0.6-0.1c1.2-0.2,2.1-1.4,1.8-2.6l-1.9-10.9l-0.1-0.6c-0.3-1.5,0.8-3,2.3-3.3l1.8-0.3c1.4,0,2.5,1,2.8,2.3     l2,11.3c0.2,1.4,1.6,2.5,3,2.3c3.8-0.3,7.6-0.3,11.4,0c1.5,0.1,2.8-0.9,3-2.3l2-11.3c0.2-1.3,1.3-2.3,2.6-2.4l2,0.3     c1.5,0.3,2.6,1.7,2.3,3.3l-2,11.4c-0.2,1.2,0.6,2.4,1.8,2.6c0,0,0,0,0,0l13.4,2.4l0.6,0.1c1.2,0.2,2.4-0.6,2.6-1.8l1.9-10.9l0.1-0.6     c0.3-1.5,1.7-2.6,3.3-2.3l1.8,0.3c1.3,0.5,2,1.8,1.8,3.1l-1.8,9.9c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.5,0.3-0.9,0.5-1.4     c0.2-0.5,0.5-1,0.8-1.5c0.2-0.3,0.4-0.6,0.6-0.9c1.3-1.7,3-3.1,4.9-4c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.2,0.6-0.2     c0.2-0.1,0.4-0.2,0.6-0.2c0.6-0.2,1.1-0.3,1.7-0.4c0.2,0,0.4-0.1,0.5-0.1c0.3,0,0.7-0.1,1-0.1c0.2,0,0.4,0,0.7,0s0.5,0,0.7,0     c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.6,0.1c0.3,0,0.5,0.1,0.8,0.1c0.2,0,0.4,0.1,0.5,0.1c0.4,0.1,0.9,0.2,1.3,0.4     c0.2,0.1,0.3,0.1,0.5,0.2c0.3,0.1,0.7,0.3,1,0.5c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0.1,0.4,0.2,0.6,0.4c0.1,0.1,0.2,0.1,0.3,0.2     c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.1,0.3,0.2,0.4,0.4c0.8,0.7,1.4,1.5,2,2.3c0.1,0.1,0.1,0.2,0.2,0.3     c0.4,0.6,0.7,1.2,1,1.8c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.5,0.4,1,0.5,1.6c0.1,0.2,0.1,0.3,0.1,0.5     C183.7,167.2,202.6,134.7,234.1,122.2z M143.9,185.4c0-0.2,0.1-0.5,0.2-0.6c0.2-0.2,0.4-0.3,0.7-0.3c0.5,0,1,0.4,1,1s-0.4,1-1,1     C144.4,186.4,143.9,186,143.9,185.4z M90.9,187.7c-0.5,0-1-0.4-1-1c0-0.6,0.5-1,1-1c0.5,0,1,0.4,1,1     C91.9,187.2,91.4,187.7,90.9,187.7z M94.4,187c-0.5,0-1-0.4-1-1s0.5-1,1-1c0.5,0,1,0.4,1,1S95,187,94.4,187z M98,186.4     c-0.5,0-1-0.5-1-1c0-0.6,0.4-1,1-1s1,0.4,1,1C98.9,186,98.5,186.4,98,186.4z M148.5,185.1c0.5,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1     S147.9,185.1,148.5,185.1z M152,185.7c0.6,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1C151,186.1,151.5,185.7,152,185.7z      M88.8,195.7c-0.1,0-0.1,0-0.2,0c-0.5,0-0.9-0.3-1-0.8l-0.4-2.2c-0.1-0.5,0.3-1.1,0.8-1.2c0.5-0.1,1.1,0.3,1.1,0.8l0.4,2.2     C89.7,195.1,89.4,195.6,88.8,195.7z M102.9,193.2c-0.5,0.1-1.1-0.3-1.2-0.8l-0.4-2.2c-0.1-0.5,0.3-1.1,0.8-1.1     c0.5-0.1,1,0.3,1.2,0.8l0.4,2.2C103.8,192.6,103.5,193.1,102.9,193.2z M141.1,192.4c-0.1,0.5-0.6,0.9-1.2,0.8     c-0.5-0.1-0.9-0.6-0.8-1.2l0.4-2.2c0.1-0.5,0.6-0.9,1.2-0.8c0.5,0.1,0.9,0.6,0.8,1.1L141.1,192.4z M155.2,194.9     c-0.1,0.5-0.6,0.9-1.2,0.8c-0.5-0.1-0.8-0.5-0.8-1c0-0.1,0-0.1,0-0.2l0.4-2.2c0.1-0.5,0.6-0.9,1.1-0.8c0.5,0.1,0.9,0.6,0.8,1.2     L155.2,194.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Silk-Screen",
    className: "st7"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.7,144.4L57.7,144.4l0-0.2l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0.1-0.1l0.1-0.1             l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0,0l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0             l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1             l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0v0l-0.1,0.1             l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1             l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0,0h0.7l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0             l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1-0.1l0.1-0.1l0,0h0l0,0l0,0l0,0h0l0,0l0.1-0.1             l0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1             l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0.1l-0.1,0.1l0,0l-0.1,0.1l-0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1h-0.7L57.7,144.4L57.7,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.9,137.5l0.6,0.6l0.3,0.3l-0.3,0.3l-0.4-0.3l-2,2l0.8,0.8l0.4-0.3l0.4,0.4l-0.8,0.8l-2.1-2.2h0l0.3-0.3             l0.4,0.2l2.1-2l-0.2-0.4l0.3-0.3L55.9,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.6,151L61.6,151L61.6,151l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L61.6,151L61.6,151L61.6,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.2,142.9l-4,4l1.4,1.5l-0.9,0.9l-4-4.1l0.9-0.9l1.5,1.5l3.1-3.1l-1.5-1.5l0.9-0.9h0L50.2,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.9,140.2L50.9,140.2L50.9,140.2l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L50.9,140.2L50.9,140.2L50.9,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66,147.7l1.9,2l-0.8,0.8l-0.4-0.4l0.3-0.4l-0.9-0.9l-0.7,0.7l1,1l-0.4,0.4l0,0l-1-1l-0.8,0.8l0.9,0.9             l0.4-0.3l0.4,0.4l-0.8,0.8l-2.3-2.3l0.3-0.3l0.4,0.2l2.1-2l-0.2-0.4l0.3-0.3L66,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M47.2,129.3L47.2,129.3l0.2,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1             l0.1,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l-0.6,0.6l0,0l-0.4-0.4l0.3-0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.4-0.3l0.4,0.4l-0.6,0.6l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1             l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1             l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0L47.2,129.3L47.2,129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.3,141l-0.3,0.3l-0.4-0.3l-2.1,2l0.2,0.4l-0.3,0.3l-1.2-1.2l0.3-0.3l0.4,0.3l2.1-2l-0.2-0.4l0.3-0.3             L59.3,141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M42.5,135.1L42.5,135.1l-0.5,0.6l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0             l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-3.6,3.5l-1-1             l3.6-3.6l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l-3.8,3.7l-1-1l3.6-3.6l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-3.8,3.8l-1-1l4.9-4.9L42.5,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.4,124.6l-0.5,0.1l-0.5,0.1l-0.5,0.1l-0.5,0.1l-0.5,0.2l-0.5,0.2l-0.5,0.2l-0.5,0.2L27,126l-0.5,0.3             l-0.5,0.3l-0.5,0.3l-0.4,0.3l-0.4,0.3l-0.8,0.6l-0.6-0.6l-0.2-0.2l-0.2-0.2l-0.2-0.3l-0.1-0.3l-0.1-0.3l-0.1-0.3l-0.1-0.3l0-0.3             l0-0.3l0-0.3l0-0.3l0-0.3l0.1-0.3l0.1-0.3l0.1-0.3l0-0.1h9.7l1.5,1.5l1.2-2.3l-2.7,0.8h-9.7l0.1-0.2l0.1-0.2l0.1-0.2l0.2-0.2             l0.2-0.2l0.2-0.2l0.1-0.1h11.5l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0.4,0.4l0,0             l0,0l0,0l0,0l0,0l0,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0             l0.1,0l0.1,0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l1.4-1.4l-2-2.1l-1.4,1.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1H23.6l0.1-0.1l0.2-0.2l0.2-0.1l0.3-0.1l0.3-0.1l0.3-0.1l0.3-0.1l0.3,0l0.3,0l0.3,0l0.3,0l5.2,0.8             l2.1-2.1l0.7-0.6l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.2-0.1l0.2-0.1l0.2-0.1l0.2-0.1l0.2-0.1l0.2,0l0.2,0l0.2,0l0.2,0             l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1             l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.2l0.1,0.2l0.1,0.2l0.1,0.2l0.1,0.2l0,0.2l0,0.2l0,0.2l0,0.2l0,0.2l0,0.2             l0,0.2l0,0.2l0,0.2l0,0.2l0,0.2l0,0.2l-0.1,0.2l-0.1,0.2l-0.1,0.2l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1             l-0.1,0.1l1.7-1.6l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l2.2,2.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-3.2,3.2l-6.4,6.3l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1L34,136l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.8-0.8l0.6-0.8l0.6-0.9l0.3-0.4l0.3-0.5l0.3-0.5l0.3-0.5             l0.2-0.5l0.2-0.5l0.2-0.5l0.2-0.5l0.2-0.5l0.1-0.5l0.1-0.5l0.1-0.5l-2.4-2.4h2.1l1.5,1.5l0.1-0.2h2.8l2.5,2.5l3-3l-2.5-2.5l-3,3             h-2.8l0.8-2.6l-2.3,1.2h-2.1L31.4,124.6L31.4,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31,125.8l-0.4,1.2l-0.4,1.2l-0.2,0.6l-0.2,0.6l-0.2,0.6l-0.1,0.6l-0.1,0.5l-0.1,0.5l-0.1,0.5l0,0.5l0,0.5             l0,0.4h0l-3.3-3.3l5.5-5.4L31,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M47.3,134l0.2,0.2l3.4-1.6l0.6,0.6l-1.6,3.3l0.2,0.2l-0.3,0.3l-1-1l0.3-0.3l0.2,0.2l0.3-0.5l-0.9-0.9             l-0.5,0.3l0.2,0.2l-0.3,0.3l-1-1l0.1-0.1h2.1l0.7,0.7l0.7-1.3l0,0l-1.3,0.7h-2.1L47.3,134L47.3,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.9,146.6L53.9,146.6l-0.6,0.7l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0             l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1             l0.1,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1             l-0.1,0.1l-0.1,0.1l-0.1,0.1l-3.1,3l-1.1-1.1l3-3l0.1-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0-0.1             l0-0.1l0-0.1l0-0.1l0-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-3.5,3.5l-1.1-1.1l4.9-4.9L53.9,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M60.9,153.7l-4,4l1.4,1.5l-0.9,0.9l-4-4.1l0.9-0.9l1.5,1.5l3.1-3.1l-1.5-1.5l0.9-0.9h0L60.9,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.3,134.9l0.6,0.6l0.3,0.3l-0.3,0.3l-0.4-0.3l-2,2l0.8,0.8l0.4-0.3l0.4,0.4l-0.8,0.8l-2.1-2.2l0,0l0.3-0.3             l0.4,0.2l2.1-2l-0.2-0.4l0.3-0.3L53.3,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.2,144.9l1.1,1.1l0,0l0,0l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.5-0.5             l-0.6,0.6l0.2,0.4l-0.3,0.3l-1.2-1.2l0.3-0.3l0.4,0.2l0.5-0.5h1.1l0.5,0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.5-0.5l-0.9,0.9l0,0h-1.1l1.6-1.5l-0.2-0.4             l0.3-0.3L63.2,144.9z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Motoren-Pinleiste",
    className: "st8",
    d: "M154.5,175.1h14.9v-6.7h-14.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Motoren-Pinleiste_00000107589385642390016050000006671797075869069747_",
    className: "st8",
    d: "M154.5,157.2h14.9v-8.3h-14.9         V157.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Power"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.1,129h2.6l-3.2,4.5l0.6-3.2l-3.2,0l4-4.5L211.1,129z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Taste_B_00000082349505263425710090000011385801950500053397_"
  }, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "ledglow",
    x: "-75%",
    y: "-75%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: 1,
    in: "SourceAlpha",
    result: "thicken"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "thicken",
    result: "blurred"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255, 17, 77)",
    result: "glowColor"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "glowColor",
    in2: "blurred",
    operator: "in",
    result: "ledglow_colored"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "ledglow_colored"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 166.8,
    y: 82.1,
    width: 21.8,
    height: 21.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.8,
    y: 82.1,
    width: 21.8,
    height: 21.8,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.2,100.2l-2.6-2.6l3.1-3.1l2.6,2.6L186.2,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M179,105.2l0,0.3l-0.1,0.3l-0.2,0.2l-0.3,0.1l-0.3,0h-4.6l-0.3,0l-0.3-0.1l-0.2-0.2l-0.1-0.3l0-0.3v-4.6                     l0-0.3l0.1-0.3l0.2-0.2l0.3-0.1l0.3,0h4.6l0.3,0l0.3,0.1l0.2,0.2l0.1,0.3l0,0.3V105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lautsprecher_00000003806582182474844270000009995606103785087383_",
    className: "st11",
    d: "M158.1,125h15.1                     c0.2,0,0.3-0.1,0.4-0.2l3.9-3.9c0.1-0.1,0.2-0.3,0.2-0.4v-15.1c0-0.2-0.1-0.3-0.2-0.4l-3.9-3.9c-0.1-0.1-0.3-0.2-0.4-0.2h-15.1                     c-0.2,0-0.3,0.1-0.4,0.2l-3.9,3.9c-0.1,0.1-0.2,0.3-0.2,0.4v15.1c0,0.2,0.1,0.3,0.2,0.4l3.9,3.9C157.8,124.9,158,125,158.1,125z                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "184.6,97.7 186,99.1 187,98.1 187.1,98.1 187.1,98 187.7,97.5 187.9,97.3 188.1,97 189,96.1                     187.6,94.7 186.5,95.9 186.3,96.1 186.2,96.1 186.1,96.3 185.9,96.5 185.7,96.6                 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.3,94.4l0.3,0.3l1.4,1.4l7.6,7.6l1.4,1.4l0.3,0.3c0.3,0.3,0.7,0.3,1,0l11-11c0.3-0.3,0.3-0.7,0-1                     l-0.3-0.3l-1.4-1.4l-7.6-7.6l-1.4-1.4l-0.3-0.3c-0.3-0.3-0.7-0.3-1,0l-11,11C187,93.7,187,94.1,187.3,94.4z M199.9,86.2                     c-0.6,0.6-1.4,0.6-2,0c-0.6-0.5-0.6-1.4,0-2c0.6-0.5,1.4-0.5,2,0C200.4,84.8,200.4,85.7,199.9,86.2z M206.5,92.9                     c0.5-0.6,1.4-0.6,2,0c0.5,0.6,0.5,1.4,0,2c-0.6,0.6-1.5,0.6-2,0C206,94.4,206,93.5,206.5,92.9z M197.9,101.6                     c0.6-0.6,1.4-0.6,2,0c0.6,0.6,0.6,1.4,0,2s-1.4,0.6-2,0C197.3,103.1,197.3,102.2,197.9,101.6z M195.3,90.4c1.9-1.9,5.1-1.9,7,0                     c1.9,1.9,1.9,5.1,0,7c-1.9,1.9-5.1,1.9-7,0C193.4,95.5,193.4,92.4,195.3,90.4z M189.2,92.9c0.6-0.6,1.4-0.6,2,0                     c0.6,0.6,0.6,1.4,0,2c-0.6,0.6-1.4,0.6-2,0C188.6,94.4,188.6,93.5,189.2,92.9z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M166.8,92.5l0-0.6l0.1-0.5l0.1-0.5l0.1-0.5l0.1-0.5l0.2-0.5l0.2-0.5l0.2-0.5l0.2-0.5l0.3-0.5l0.3-0.4             l0.3-0.4l0.3-0.4l0.3-0.4l0.4-0.4l0.4-0.4l0.4-0.3l0.4-0.3l0.4-0.3l0.4-0.3l0.5-0.3l0.5-0.2l0.5-0.2l0.5-0.2l0.5-0.2l0.5-0.1             l0.5-0.1l0.5-0.1l0.5-0.1l0.6,0l0.6,0l0.6,0l0.6,0l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.2L182,83l0.5,0.2l0.5,0.2l0.5,0.3             l0.4,0.3l0.4,0.3l0.4,0.3l0.4,0.3l0.4,0.4l0.4,0.4l0.3,0.4l0.3,0.4l0.3,0.4l0.3,0.4l0.3,0.5l0.2,0.5l0.2,0.5l0.2,0.5l0.2,0.5             l0.1,0.5l0.1,0.5l0.1,0.5l0.1,0.5l0,0.6l0,0.6l0,0.6l0,0.6l-0.1,0.5l-0.1,0.5l-0.1,0.5l-0.1,0.5l-0.2,0.5l-0.2,0.5l-0.2,0.5             l-0.2,0.5l-0.3,0.5l-0.3,0.4l-0.3,0.4l-0.3,0.4l-0.3,0.4l-0.4,0.4l-0.4,0.4l-0.4,0.3l-0.4,0.3l-0.4,0.3l-0.4,0.3l-0.5,0.3             l-0.5,0.2l-0.5,0.2l-0.5,0.2l-0.5,0.2l-0.5,0.1l-0.5,0.1l-0.5,0.1l-0.5,0.1l-0.6,0l-0.6,0l-0.6,0l-0.6,0l-0.5-0.1l-0.5-0.1             l-0.5-0.1l-0.5-0.1l-0.5-0.2l-0.5-0.2l-0.5-0.2l-0.5-0.2l-0.5-0.3l-0.4-0.3l-0.4-0.3l-0.4-0.3l-0.4-0.3l-0.4-0.4l-0.4-0.4             l-0.3-0.4l-0.3-0.4l-0.3-0.4l-0.3-0.4l-0.3-0.5l-0.2-0.5l-0.2-0.5l-0.2-0.5l-0.2-0.5l-0.1-0.5l-0.1-0.5l-0.1-0.5l-0.1-0.5l0-0.6             l0-0.6h1.9l0,0.5l0,0.5l0.1,0.4l0.1,0.4l0.1,0.4l0.1,0.4l0.1,0.4l0.2,0.4l0.2,0.4l0.2,0.4l0.2,0.4l0.2,0.4l0.3,0.4l0.3,0.3             l0.3,0.3l0.3,0.3l0.3,0.3l0.3,0.3l0.3,0.3l0.4,0.3l0.4,0.2l0.4,0.2l0.4,0.2l0.4,0.2l0.4,0.2l0.4,0.1l0.4,0.1l0.4,0.1l0.4,0.1             l0.4,0.1l0.5,0l0.5,0l0.5,0l0.5,0l0.4-0.1l0.4-0.1l0.4-0.1l0.4-0.1l0.4-0.1l0.4-0.2l0.4-0.2l0.4-0.2l0.4-0.2l0.4-0.2l0.4-0.3             l0.3-0.3l0.3-0.3l0.3-0.3l0.3-0.3l0.3-0.3l0.3-0.3l0.3-0.4l0.2-0.4l0.2-0.4l0.2-0.4l0.2-0.4l0.2-0.4l0.1-0.4l0.1-0.4l0.1-0.4             l0.1-0.4l0.1-0.4l0-0.5l0-0.5l0-0.5l0-0.5l-0.1-0.4l-0.1-0.4l-0.1-0.4l-0.1-0.4l-0.1-0.4l-0.2-0.4l-0.2-0.4l-0.2-0.4l-0.2-0.4             l-0.2-0.4l-0.3-0.4l-0.3-0.3l-0.3-0.3l-0.3-0.3l-0.3-0.3l-0.3-0.3l-0.3-0.3l-0.4-0.3l-0.4-0.2l-0.4-0.2l-0.4-0.2l-0.4-0.2             l-0.4-0.2l-0.4-0.1l-0.4-0.1l-0.4-0.1l-0.4-0.1l-0.4-0.1l-0.5,0l-0.5,0l-0.5,0l-0.5,0l-0.4,0.1l-0.4,0.1l-0.4,0.1l-0.4,0.1             l-0.4,0.1l-0.4,0.2l-0.4,0.2l-0.4,0.2l-0.4,0.2l-0.4,0.2l-0.4,0.3l-0.3,0.3l-0.3,0.3l-0.3,0.3l-0.3,0.3l-0.3,0.3l-0.3,0.3             l-0.3,0.4l-0.2,0.4l-0.2,0.4l-0.2,0.4l-0.2,0.4l-0.2,0.4l-0.1,0.4l-0.1,0.4l-0.1,0.4l-0.1,0.4l-0.1,0.4l0,0.5l0,0.5h-1.9v0             L166.8,92.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.6,89.7l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1             l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0.1,0l0.1,0l0.1,0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1             l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0             l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0h-2.2v-1.1h1.3h0.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h-0.9h0v1.8h-1.3v-2.8h1.3h0.7l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0-0.1l0-0.1l0-0.1l0-0.1l0,0l0,0l0,0             l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0h-0.7v1.7h-1.3             v-2.8H177.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Taste_A_00000173864098007574672720000003462884650823797891_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.8,93.3l2.1,6.7h-1.4l-0.4-1.4h0h-1.8l-0.4,1.4h-1.4l0.8-2.5h1.3h1.2l-0.6-2.4l-0.6,2.4h-1.3l1.3-4.2H63.8             z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.2,82.1L48.5,96.7l14.6,14.6l14.6-14.6L63.2,82.1z M51.2,96.7l12-12l12,12l-12,12L51.2,96.7z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Reset",
    className: "st8",
    d: "M155.7,29l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1         l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1v2.3         l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1         l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0h0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1         l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1v-1.8l-0.9,0.8l-0.6-0.5         l1.9-2l1.8,2l-0.6,0.5l-0.8-0.8v1.8l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0         l0,0l0,0l0,0l0,0l0,0l0,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0h0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0         l0.1,0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1         v-2.4l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0h0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0         l-0.6-0.7l0.1-0.1l0,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0h0L155.7,29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155.7,16.4l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1         l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0         l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1         l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1         l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1         l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1-0.1L157,19l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1         l-0.1-0.1L156,18l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1h0.6l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1         l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0         l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0         l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1         l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1         l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1         l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1h-0.6         l0-0.1L155.7,16.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M158.7,16.2h1.2V17h-1.2v1.3h-0.8V17h-1.2v-0.8h1.2V15h0.8V16.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M81.5,16.2l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0.1-0.1l0.1-0.1l0.1-0.1L82,15l0.1-0.1l0.1-0.1l0.1-0.1         l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0         l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1         l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1         l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1L86.4,18l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1L86,18.5l-0.1,0.1l-0.1,0.1l-0.1,0.1         l-0.1,0.1l-0.1,0.1l-0.1,0.1L85.2,19l-0.1,0L85,19l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0L83,18.9l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1L82,18         l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1h0.6l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1         l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0l0.1,0         l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0l0.1,0         l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1         l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1         l-0.1-0.1L85.6,15l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0         l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0l-0.1,0.1L83,14.9l-0.1,0.1L82.8,15         l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1l0,0.1h-0.6         l0-0.1L81.5,16.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.8,16.9h-3.2v-0.9h3.2V16.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,68.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2V70l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,63.6l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,68.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2V70l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,63.6l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,68.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2V70l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,63.6l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,79.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,75l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2L108,75l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,102.2l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,97.7l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.9,133.8v-2h2v2H121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.9,130.7v-2h2v2H121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M116.7,130.7v-2h2v2H116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M116.7,133.8v-2h2v2H116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,90.8l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,86.3l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2V87l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,90.8l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,86.3l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2V87l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,102.2l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,97.7l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,90.8l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,86.3l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2V87l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,113.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2L144,116l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,109.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,79.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,75l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,102.2l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,97.7l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,79.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,75l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,90.8l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,86.3l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2V87l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,113.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,109.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M136.1,133.8v-2h2v2H136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M136.1,130.7v-2h2v2H136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.9,130.7v-2h2v2H130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.9,133.8v-2h2v2H130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,113.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,109.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M107.7,133.8v-2h2v2H107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M107.7,130.7v-2h2v2H107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M102.5,130.7v-2h2v2H102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M102.5,133.8v-2h2v2H102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,102.2l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,97.7l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,68.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2V70l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,63.6l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,102.2l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,97.7l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,113.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,109.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1             l-0.1-0.2l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,113.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,109.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,68.1l0.2,0l0.2,0.1l0.1,0.2l0,0.2V70l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121,63.6l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,79.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.3,75l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,79.5l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M143.7,75l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2L142,75l0.2,0H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,90.8l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2v-1.2l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M132.4,86.3l0.2,0l0.2,0.1l0.1,0.2l0,0.2v1.2l0,0.2l-0.1,0.2l-0.2,0.1l-0.2,0h-1.5l-0.2,0l-0.2-0.1l-0.1-0.2             l0-0.2V87l0-0.2l0.1-0.2l0.2-0.1l0.2,0H132.4z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Touchpins"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Plus-Pin",
    className: "st15",
    d: "M175.5,3.3c-2.5,0-4.8,0.7-6.8,1.9c-0.2,0.1-0.4,0.2-0.5,0.3c0,0,0,0-0.1,0         c-0.2,0.2-0.5,0.3-0.7,0.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3         c-0.2,0.2-0.4,0.4-0.6,0.6c-0.6,0.6-1,1.3-1.5,2c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1,0.2-0.2,0.5-0.4,0.8c-0.1,0.1-0.1,0.2-0.1,0.4         c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.2,0.6-0.3,1c-0.1,0.2-0.1,0.5-0.2,0.8c0,0.1,0,0.3-0.1,0.4c0,0.1,0,0.3-0.1,0.4         c0,0.2-0.1,0.5-0.1,0.7c0,0.1,0,0.2,0,0.4c0,0.2,0,0.5,0,0.7c0,7.2,5.8,13,13,13c0.4,0,0.8,0,1.2-0.1c1.2-0.1,2.4-0.4,3.5-0.8         c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.1,0.4-0.3,0.6-0.4         c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.3-0.4,0.5-0.6         c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.3-0.5,0.4-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.5,0.3-0.7c0.3-0.6,0.5-1.3,0.7-1.9         c0.1-0.3,0.1-0.6,0.2-0.9v0c0.1-0.8,0.2-1.5,0.2-2.3C188.5,9.2,182.7,3.3,175.5,3.3z M175.5,22c-3.1,0-5.7-2.5-5.7-5.7         c0-3.1,2.5-5.7,5.7-5.7c3.1,0,5.7,2.5,5.7,5.7C181.2,19.5,178.7,22,175.5,22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Minus-Pin",
    className: "st15",
    d: "M80.4,15.5L80.4,15.5C80.5,15.4,80.5,15.4,80.4,15.5c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.5-0.1-0.7         c0-0.1-0.1-0.3-0.1-0.4c-0.2-1.2-0.6-2.4-1.2-3.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.2-0.3-0.3-0.4         c-0.2-0.3-0.4-0.5-0.6-0.8c0,0,0,0,0,0c-0.2-0.2-0.4-0.5-0.6-0.7c-2.4-2.5-5.7-4.1-9.5-4.1c-7.2,0-13.1,5.8-13.1,13.1         c0,0.6,0,1.2,0.1,1.8v0c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.4c0,0.3,0.1,0.6,0.2,0.8c0,0.2,0.1,0.4,0.2,0.6c0,0.1,0.1,0.3,0.1,0.4         c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.1,0.2,0.2,0.4         c0.5,0.7,1,1.3,1.6,1.9c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.2,0.4,0.3,0.6,0.5c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.2,0.5,0.3,0.8,0.5         c0.1,0,0.1,0.1,0.2,0.1c0.3,0.2,0.6,0.3,0.9,0.4c0.3,0.1,0.6,0.3,1,0.4c0.4,0.1,0.8,0.2,1.2,0.4c0.3,0.1,0.6,0.1,0.9,0.2         c0.5,0.1,1,0.2,1.6,0.2c0.2,0,0.4,0,0.7,0c7.2,0,13.1-5.8,13.1-13.1C80.5,16,80.5,15.7,80.4,15.5z M67.4,21.9         c-3.1,0-5.7-2.5-5.7-5.7c0-3.1,2.5-5.7,5.7-5.7c3.1,0,5.7,2.5,5.7,5.7C73.1,19.4,70.5,21.9,67.4,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin_3",
    className: "st15",
    d: "M233.7,97.7c-0.6-0.2-1.3-0.4-2-0.5c-0.1,0-0.2,0-0.4-0.1c-0.6-0.1-1.2-0.1-1.8-0.1         c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.4,0c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.6,0.1-1,0.2c-0.2,0-0.3,0.1-0.5,0.1         c-0.4,0.1-0.8,0.2-1.2,0.4c-0.2,0.1-0.5,0.2-0.7,0.3s-0.5,0.2-0.7,0.4c-0.2,0.1-0.5,0.2-0.7,0.4c-0.2,0.2-0.5,0.3-0.7,0.5         c-0.2,0.2-0.5,0.3-0.7,0.5c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.1-0.2,0.2c-2.4,2.4-3.8,5.6-3.8,9.2         c0,7.2,5.8,13,13,13c0.3,0,0.6,0,0.9,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.8-0.1c0.3,0,0.6-0.1,0.8-0.2c0.1,0,0.2,0,0.3-0.1         c0.3-0.1,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.1,0.6-0.2c5-1.8,8.5-6.6,8.5-12.2C242.6,104.3,238.9,99.4,233.7,97.7z M229.6,115.7         c-3.1,0-5.7-2.5-5.7-5.7s2.5-5.7,5.7-5.7c3.1,0,5.7,2.5,5.7,5.7S232.7,115.7,229.6,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin_2",
    className: "st15",
    d: "M188.2,200.7c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.6-0.3-1.1-0.5-1.6c-0.1-0.1-0.1-0.2-0.2-0.3         c-0.3-0.6-0.6-1.2-1-1.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.6-0.9-1.2-1.6-2-2.3c-0.1-0.1-0.3-0.2-0.4-0.4c-0.2-0.2-0.4-0.3-0.6-0.5         c-0.2-0.1-0.3-0.2-0.5-0.4c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3-0.2-0.7-0.3-1-0.5c-0.2-0.1-0.3-0.1-0.5-0.2         c-0.4-0.2-0.8-0.3-1.3-0.4c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3-0.1-0.5-0.1-0.8-0.1c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.4,0-0.7,0         c-0.2,0-0.4,0-0.7,0s-0.5,0-0.7,0c-0.3,0-0.7,0-1,0.1c-0.2,0-0.4,0-0.5,0.1c-0.6,0.1-1.2,0.2-1.7,0.4c-0.2,0.1-0.4,0.1-0.6,0.2         c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0.1-0.4,0.2-0.6,0.3c-1.9,0.9-3.6,2.3-4.9,4c-0.2,0.3-0.4,0.6-0.6,0.9c-0.3,0.5-0.6,1-0.8,1.5         c-0.2,0.4-0.4,0.9-0.5,1.4c-0.1,0.2-0.1,0.3-0.2,0.5c-0.3,1.2-0.5,2.4-0.5,3.7c0,7.3,5.9,13.2,13.2,13.2s13.2-5.9,13.2-13.2         C188.6,202.6,188.5,201.6,188.2,200.7z M175.3,209.3c-3.1,0-5.7-2.5-5.7-5.7c0-3.1,2.5-5.7,5.7-5.7s5.7,2.5,5.7,5.7         C181,206.8,178.5,209.3,175.3,209.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin_1",
    className: "st15",
    d: "M80.4,200.5c-0.1-0.3-0.2-0.6-0.3-0.9c0,0,0-0.1,0-0.1c-0.1-0.3-0.2-0.5-0.3-0.8         c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.3-0.2-0.5-0.4-0.8c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.2-0.3-0.5-0.5-0.7c-0.2-0.2-0.3-0.5-0.5-0.7         c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.2-0.3-0.4-0.5-0.6c0,0,0,0,0,0c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.6-0.5-0.9-0.7         c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.6-0.3-0.9-0.5c-0.3-0.2-0.6-0.3-0.9-0.4c-0.8-0.3-1.6-0.6-2.4-0.8c-0.2,0-0.3-0.1-0.5-0.1         c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5-0.1c-0.4,0-0.9-0.1-1.3-0.1c-0.5,0-0.9,0-1.4,0.1c-0.2,0-0.4,0-0.7,0.1         c-0.7,0.1-1.3,0.2-1.9,0.4c-1.2,0.4-2.4,1-3.5,1.7c-0.2,0.1-0.3,0.2-0.5,0.4c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2,0.1-0.3,0.3-0.5,0.4         c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1,0.1-0.3,0.3-0.4,0.5c-0.4,0.5-0.8,1-1.2,1.5c-0.2,0.4-0.5,0.7-0.7,1.1c-0.1,0.2-0.2,0.4-0.3,0.6         c-0.2,0.4-0.3,0.8-0.5,1.2c-0.5,1.4-0.8,3-0.8,4.6c0,7.4,6,13.3,13.3,13.3s13.3-6,13.3-13.3C80.8,202.6,80.6,201.5,80.4,200.5z          M67.5,209.5c-3.2,0-5.7-2.5-5.7-5.7c0-3.1,2.6-5.7,5.7-5.7c3.1,0,5.7,2.6,5.7,5.7C73.2,206.9,70.6,209.5,67.5,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin_0",
    className: "st15",
    d: "M13.3,96.9c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0-0.6,0.1c-0.8,0.1-1.6,0.2-2.4,0.5         C4.2,99,0.2,104.1,0.2,110c0,5.4,3.3,10.1,8,12.1c0.4,0.2,0.8,0.3,1.2,0.4c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.7,0.1         c0.2,0,0.4,0.1,0.6,0.1c0.4,0,0.9,0.1,1.3,0.1c7.2,0,13.1-5.8,13.1-13.1C26.4,102.8,20.6,96.9,13.3,96.9z M13.3,115.7         c-3.1,0-5.7-2.5-5.7-5.7s2.5-5.7,5.7-5.7s5.7,2.5,5.7,5.7S16.5,115.7,13.3,115.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "JacDac"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000056389708305240723870000015083357615805203126_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.3,187.3c0.1-0.3,0.2-0.6,0.1-0.9c-0.1-0.8-0.8-1.3-1.6-1.3c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.4,1-1.3,1.8                 c0.1,0.3,0.2,0.6,0.4,0.8l1.7,9.5c0.1,0.6,0.7,1,1.3,0.9l0.3,0c0.6-0.1,1-0.7,0.9-1.3L92.3,187.3z M90.9,187.7c-0.5,0-1-0.4-1-1                 c0-0.6,0.5-1,1-1c0.5,0,1,0.4,1,1C91.9,187.2,91.4,187.7,90.9,187.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_00000097474104168688435380000017146066176934872713_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.8,186.7L95.8,186.7c0.1-0.3,0.2-0.6,0.1-0.9c-0.2-0.8-1-1.4-1.8-1.3c-0.9,0.2-1.4,1-1.3,1.8                 c0.1,0.3,0.2,0.6,0.4,0.8l1.9,10.9c0.1,0.6,0.7,1,1.3,0.9l0.3-0.1c0.6-0.1,1-0.7,0.9-1.3L95.8,186.7z M94.4,187c-0.5,0-1-0.4-1-1                 s0.5-1,1-1c0.5,0,1,0.4,1,1S95,187,94.4,187z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000170966461034420328180000007072736512868471690_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.4,186.1c0.1-0.3,0.2-0.6,0.1-0.9c-0.1-0.3-0.2-0.6-0.4-0.8c-0.3-0.4-0.8-0.5-1.4-0.4                 c-0.8,0.2-1.4,1-1.3,1.8c0.1,0.3,0.2,0.6,0.4,0.8l1.9,10.9c0.1,0.6,0.7,1,1.3,0.9l0.3-0.1c0.6-0.1,1-0.7,0.9-1.3L99.4,186.1z                  M98,186.4c-0.5,0-1-0.5-1-1c0-0.6,0.4-1,1-1s1,0.4,1,1C98.9,186,98.5,186.4,98,186.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "LINE_00000067943469928557821020000008144218218959454621_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.7,184.5c-0.8-0.1-1.7,0.4-1.8,1.3c-0.1,0.3,0,0.6,0.1,0.9v0l-1.9,10.9c-0.1,0.6,0.3,1.2,0.9,1.3                 l0.3,0.1c0.6,0.1,1.2-0.3,1.3-0.9l1.9-10.9c0.2-0.2,0.4-0.5,0.4-0.8C150.1,185.5,149.6,184.7,148.7,184.5z M148.5,187                 c-0.5,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S149,187,148.5,187z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000111881289479611605620000015351086674710880703_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M145.2,183.9c-0.5-0.1-1.1,0.1-1.4,0.5c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3,0,0.6,0.1,0.9l-1.7,9.5                 c-0.1,0.6,0.3,1.2,0.9,1.3l0.3,0c0.6,0.1,1.2-0.3,1.3-0.9l1.7-9.5c0.2-0.2,0.4-0.5,0.4-0.8C146.6,184.8,146,184,145.2,183.9z                  M144.9,186.4c-0.6,0-1-0.4-1-1c0-0.2,0.1-0.5,0.2-0.6c0.2-0.2,0.4-0.3,0.7-0.3c0.5,0,1,0.4,1,1S145.5,186.4,144.9,186.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000115515919514279782110000016854648703813804954_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M152.3,185.1c-0.1,0-0.2,0-0.3,0c-0.8,0-1.4,0.5-1.5,1.3c-0.1,0.3,0,0.6,0.1,0.9l-1.9,10.9                 c-0.1,0.6,0.3,1.2,0.9,1.3l0.3,0.1c0.6,0.1,1.2-0.3,1.3-0.9l1.9-10.9c0.2-0.2,0.4-0.5,0.4-0.8                 C153.7,186.1,153.1,185.3,152.3,185.1z M152,187.7c-0.5,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1                 C153,187.2,152.5,187.7,152,187.7z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Steckleiste"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7,156.1v13c0,0.3,0.3,0.6,0.6,0.6h108c0.3,0,0.6-0.3,0.6-0.6v-13c0-0.3-0.3-0.6-0.6-0.6h-108         C67.9,155.5,67.7,155.8,67.7,156.1z M124,157.2v3.6h-3.6v-3.6H124z M73.6,168H70v-3.6h3.6V168z M73.6,160.8H70v-3.6h3.6V160.8z          M80.8,168h-3.6v-3.6h3.6V168z M80.8,160.8h-3.6v-3.6h3.6V160.8z M88,168h-3.6v-3.6H88V168z M88,160.8h-3.6v-3.6H88V160.8z          M95.2,168h-3.6v-3.6h3.6V168z M95.2,160.8h-3.6v-3.6h3.6V160.8z M102.4,168h-3.6v-3.6h3.6V168z M102.4,160.8h-3.6v-3.6h3.6V160.8z          M109.6,168H106v-3.6h3.6V168z M109.6,160.8H106v-3.6h3.6V160.8z M116.8,168h-3.6v-3.6h3.6V168z M116.8,160.8h-3.6v-3.6h3.6V160.8z          M124,168h-3.6v-3.6h3.6V168z M131.2,168h-3.6v-3.6h3.6V168z M131.2,160.8h-3.6v-3.6h3.6V160.8z M138.4,168h-3.6v-3.6h3.6V168z          M138.4,160.8h-3.6v-3.6h3.6V160.8z M145.6,168H142v-3.6h3.6V168z M145.6,160.8H142v-3.6h3.6V160.8z M152.8,168h-3.6v-3.6h3.6V168z          M152.8,160.8h-3.6v-3.6h3.6V160.8z M160,168h-3.6v-3.6h3.6V168z M160,160.8h-3.6v-3.6h3.6V160.8z M167.2,168h-3.6v-3.6h3.6V168z          M167.2,160.8h-3.6v-3.6h3.6V160.8z M174.4,168h-3.6v-3.6h3.6V168z M174.4,160.8h-3.6v-3.6h3.6V160.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Aussen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,164.4v3.6h3.6v-3.6H70z M73.1,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,164.4v3.6h3.6v-3.6H77.2z M80.3,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,164.4v3.6H88v-3.6H84.4z M87.5,167.4H85V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,164.4v3.6h3.6v-3.6H91.6z M94.7,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,164.4v3.6h3.6v-3.6H98.8z M101.9,167.4h-2.5V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,164.4v3.6h3.6v-3.6H106z M109.1,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,164.4v3.6h3.6v-3.6H113.2z M116.3,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,164.4v3.6h3.6v-3.6H120.4z M123.5,167.4H121V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,164.4v3.6h3.6v-3.6H127.6z M130.7,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,164.4v3.6h3.6v-3.6H134.8z M137.9,167.4h-2.5V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,164.4v3.6h3.6v-3.6H142z M145.1,167.4h-2.4V165h2.4V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,164.4v3.6h3.6v-3.6H149.2z M152.3,167.4h-2.5V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,164.4v3.6h3.6v-3.6H156.4z M159.5,167.4H157V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,164.4v3.6h3.6v-3.6H163.6z M166.7,167.4h-2.5V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,164.4v3.6h3.6v-3.6H170.8z M173.9,167.4h-2.5V165h2.5V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,157.2v3.6h3.6v-3.6H70z M73.1,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,157.2v3.6h3.6v-3.6H77.2z M80.3,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,157.2v3.6H88v-3.6H84.4z M87.5,160.2H85v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,157.2v3.6h3.6v-3.6H91.6z M94.7,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,157.2v3.6h3.6v-3.6H98.8z M101.9,160.2h-2.5v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,157.2v3.6h3.6v-3.6H106z M109.1,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,157.2v3.6h3.6v-3.6H113.2z M116.3,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,157.2v3.6h3.6v-3.6H120.4z M123.5,160.2H121v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,157.2v3.6h3.6v-3.6H127.6z M130.7,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,157.2v3.6h3.6v-3.6H134.8z M137.9,160.2h-2.5v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,157.2v3.6h3.6v-3.6H142z M145.1,160.2h-2.4v-2.5h2.4V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,157.2v3.6h3.6v-3.6H149.2z M152.3,160.2h-2.5v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,157.2v3.6h3.6v-3.6H156.4z M159.5,160.2H157v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,157.2v3.6h3.6v-3.6H163.6z M166.7,160.2h-2.5v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,157.2v3.6h3.6v-3.6H170.8z M173.9,160.2h-2.5v-2.5h2.5V160.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Innen"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.2,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.4,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.6,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.8,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.4,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.6,
    y: 165,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.8,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 165,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.2,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.4,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.6,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.8,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Pfad_x3E_",
    className: "st16",
    d: "M137.9,160.2h-2.5v-2.5h2.5V160.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.6,
    y: 157.8,
    className: "st16",
    width: 2.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.8,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 157.8,
    className: "st16",
    width: 2.5,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fuesse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.3,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.3,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.7,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.1,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.9,
    y: 169.7,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.3,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.3,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.7,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.1,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.9,
    y: 152.4,
    className: "st17",
    width: 1.4,
    height: 3.1
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Mikrofon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M203.5,113.7v7.2c0,0.3-0.3,0.6-0.6,0.6h-9.2c-0.3,0-0.6-0.3-0.6-0.6v-7.2c0-0.3,0.3-0.6,0.6-0.6h9.2         C203.2,113.2,203.5,113.4,203.5,113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M203.2,113.9v6.8c0,0.3-0.2,0.5-0.5,0.5h-8.7c-0.3,0-0.5-0.2-0.5-0.5v-6.8c0-0.3,0.2-0.5,0.5-0.5h8.7         C203,113.4,203.2,113.6,203.2,113.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 117.3,
    r: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "LitMicrophone",
    style: {
      display: "none"
    },
    className: "redFill",
    d: "M203.2,113.9v6.8c0,0.3-0.2,0.5-0.5,0.5h-8.7c-0.3,0-0.5-0.2-0.5-0.5v-6.8c0-0.3,0.2-0.5,0.5-0.5h8.7         C203,113.4,203.2,113.6,203.2,113.9z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 117.3,
    r: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.2,100.2l-2.6-2.6l3.1-3.1l2.6,2.6L186.2,100.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M202.1,84.3l-2.6-2.6l3.1-3.1l2.6,2.6L202.1,84.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.2,109.3l-2.6-2.6l3.1-3.1l2.6,2.6L195.2,109.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M211.1,93.3l-2.6-2.6l3.1-3.1l2.6,2.6L211.1,93.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M172.2,63.3l-1.2-2.6l11.6-5.4l1.2,2.6L172.2,63.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M174.6,68.5l-1.2-2.6l11.6-5.4l1.2,2.6L174.6,68.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M177,73.6l-1.2-2.6l11.6-5.4l1.2,2.6L177,73.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179.4,78.8l-1.2-2.6l11.6-5.4l1.2,2.6L179.4,78.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M180.2,130.8l7.8,6.1l-1.7,2.2l-7.8-6.1L180.2,130.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M189.5,145.6l7.6,5.9l-2.6,3.4l-7.6-5.9L189.5,145.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.2,130.6l7.6,5.9l-2.6,3.4l-7.6-5.9L201.2,130.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M183.7,126.3l7.8,6.1l-1.7,2.2l-7.8-6.1L183.7,126.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M158.9,125.3l0,0.3l-0.1,0.3l-0.2,0.2l-0.3,0.1l-0.3,0h-4.6l-0.3,0l-0.3-0.1l-0.2-0.2l-0.1-0.3l0-0.3v-4.6     l0-0.3l0.1-0.3l0.2-0.2l0.3-0.1l0.3,0h4.6l0.3,0l0.3,0.1l0.2,0.2l0.1,0.3l0,0.3V125.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179,125.3l0,0.3l-0.1,0.3l-0.2,0.2l-0.3,0.1l-0.3,0h-4.6l-0.3,0l-0.3-0.1l-0.2-0.2l-0.1-0.3l0-0.3v-4.6l0-0.3     l0.1-0.3l0.2-0.2l0.3-0.1l0.3,0h4.6l0.3,0l0.3,0.1l0.2,0.2l0.1,0.3l0,0.3V125.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179,105.2l0,0.3l-0.1,0.3l-0.2,0.2l-0.3,0.1l-0.3,0h-4.6l-0.3,0l-0.3-0.1l-0.2-0.2l-0.1-0.3l0-0.3v-4.6l0-0.3     l0.1-0.3l0.2-0.2l0.3-0.1l0.3,0h4.6l0.3,0l0.3,0.1l0.2,0.2l0.1,0.3l0,0.3V105.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M158.9,105.2l0,0.3l-0.1,0.3l-0.2,0.2l-0.3,0.1l-0.3,0h-4.6l-0.3,0l-0.3-0.1l-0.2-0.2l-0.1-0.3l0-0.3v-4.6     l0-0.3l0.1-0.3l0.2-0.2l0.3-0.1l0.3,0h4.6l0.3,0l0.3,0.1l0.2,0.2l0.1,0.3l0,0.3V105.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M65.4,76.3l-1.2,2.6l-11.6-5.4l1.2-2.6L65.4,76.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M67.8,71.1l-1.2,2.6L55,68.3l1.2-2.6L67.8,71.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M70.2,66L69,68.5l-11.6-5.4l1.2-2.6L70.2,66z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M72.6,60.8l-1.2,2.6L59.8,58l1.2-2.6L72.6,60.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73,155.6h-2.5v-5.2H73V155.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73,173.6h-2.5v-5.2H73V173.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.2,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.2,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.4,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.4,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.7,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.7,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.9,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.9,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.1,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.1,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M116.3,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M116.3,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.5,155.6H121v-5.2h2.5V155.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.5,173.6H121v-5.2h2.5V173.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.7,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.7,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M137.9,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M137.9,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M145.1,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M145.1,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M152.3,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M152.3,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M159.5,155.6H157v-5.2h2.5V155.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M159.5,173.6H157v-5.2h2.5V173.6z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M166.7,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M166.7,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.9,155.6h-2.5v-5.2h2.5V155.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.9,173.6h-2.5v-5.2h2.5V173.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M49.3,106.7l-2.6,2.6l-3.1-3.1l2.6-2.6L49.3,106.7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M33.3,90.7l-2.6,2.6l-3.1-3.1l2.6-2.6L33.3,90.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M58.3,97.6l-2.6,2.6l-3.1-3.1l2.6-2.6L58.3,97.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.4,81.7l-2.6,2.6l-3.1-3.1l2.6-2.6L42.4,81.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M59.4,32.9h3.4v4h-3.4V32.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M59.4,39.2h3.4v4h-3.4V39.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.2,39.2h3.4v4h-3.4V39.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.2,32.9h3.4v4h-3.4V32.9z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Lautsprecher_00000097491445093581913290000018287520246302512032_",
    d: "M158.1,125h15.1c0.2,0,0.3-0.1,0.4-0.2l3.9-3.9         c0.1-0.1,0.2-0.3,0.2-0.4v-15.1c0-0.2-0.1-0.3-0.2-0.4l-3.9-3.9c-0.1-0.1-0.3-0.2-0.4-0.2h-15.1c-0.2,0-0.3,0.1-0.4,0.2l-3.9,3.9         c-0.1,0.1-0.2,0.3-0.2,0.4v15.1c0,0.2,0.1,0.3,0.2,0.4l3.9,3.9C157.8,124.9,158,125,158.1,125z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Anwendungs-Prozessor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5,120.3l-13.2,13.2c-0.2,0.2-0.6,0.2-0.8,0l-13.2-13.2c-0.2-0.2-0.2-0.6,0-0.8l13.2-13.2c0.2-0.2,0.6-0.2,0.8,0         l13.2,13.2C87.7,119.7,87.7,120.1,87.5,120.3z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Taste_B"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "193.6,106.8 195,108.2 196.1,107.1 196.1,107.1 196.1,107.1 196.3,106.9 196.5,106.7 196.6,106.6         196.7,106.5 196.9,106.3 197.2,106.1 198,105.1 196.6,103.7 195.5,104.9 195.3,105.1 195.2,105.1 195.1,105.3 194.9,105.5         194.7,105.7 194.5,105.9     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "208.7,91.7 210.1,93.1 211,92.2 211.2,92 211.4,91.8 211.5,91.7 211.6,91.6 211.8,91.4 212,91.2         213.1,90.1 211.7,88.7 210.8,89.6 210.6,89.7 210.4,89.9 210.2,90.2 210.1,90.3 210,90.4 209.8,90.6     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "199.7,82.7 201,84.1 202,83.2 202.2,83 202.4,82.8 202.5,82.7 202.6,82.6 203,82.1 203,82.1         203.2,81.9 204.1,81.1 202.7,79.7 201.6,80.8 201.4,80.9 201.2,81.2 201,81.3 201,81.4 200.8,81.5 200.5,81.8     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "184.6,97.7 186,99.1 187,98.1 187.1,98.1 187.1,98 187.7,97.5 187.9,97.3 188.1,97 189,96.1         187.6,94.7 186.5,95.9 186.3,96.1 186.2,96.1 186.1,96.3 185.9,96.5 185.7,96.6     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M195.3,97.4c1.9,1.9,5.1,1.9,7,0c1.9-1.9,1.9-5.1,0-7c-1.9-1.9-5.1-1.9-7,0C193.4,92.4,193.4,95.5,195.3,97.4         z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M187.3,94.4l0.3,0.3l1.4,1.4l7.6,7.6l1.4,1.4l0.3,0.3c0.3,0.3,0.7,0.3,1,0l11-11c0.3-0.3,0.3-0.7,0-1         l-0.3-0.3l-1.4-1.4l-7.6-7.6l-1.4-1.4l-0.3-0.3c-0.3-0.3-0.7-0.3-1,0l-11,11C187,93.7,187,94.1,187.3,94.4z M199.9,86.2         c-0.6,0.6-1.4,0.6-2,0c-0.6-0.5-0.6-1.4,0-2c0.6-0.5,1.4-0.5,2,0C200.4,84.8,200.4,85.7,199.9,86.2z M206.5,92.9         c0.5-0.6,1.4-0.6,2,0c0.5,0.6,0.5,1.4,0,2c-0.6,0.6-1.5,0.6-2,0C206,94.4,206,93.5,206.5,92.9z M197.9,101.6c0.6-0.6,1.4-0.6,2,0         c0.6,0.6,0.6,1.4,0,2s-1.4,0.6-2,0C197.3,103.1,197.3,102.2,197.9,101.6z M195.3,90.4c1.9-1.9,5.1-1.9,7,0c1.9,1.9,1.9,5.1,0,7         c-1.9,1.9-5.1,1.9-7,0C193.4,95.5,193.4,92.4,195.3,90.4z M189.2,92.9c0.6-0.6,1.4-0.6,2,0c0.6,0.6,0.6,1.4,0,2         c-0.6,0.6-1.4,0.6-2,0C188.6,94.4,188.6,93.5,189.2,92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2,94.9c0.6,0.6,1.4,0.6,2,0c0.6-0.6,0.6-1.4,0-2c-0.6-0.6-1.4-0.6-2,0C188.6,93.5,188.6,94.4,189.2,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,86.2c0.6,0.6,1.4,0.6,2,0c0.6-0.5,0.6-1.4,0-2c-0.6-0.5-1.4-0.5-2,0C197.3,84.8,197.3,85.7,197.9,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,94.9c0.5,0.6,1.4,0.6,2,0c0.5-0.6,0.5-1.4,0-2c-0.6-0.6-1.5-0.6-2,0C206,93.5,206,94.4,206.5,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,103.6c0.6,0.6,1.4,0.6,2,0s0.6-1.4,0-2c-0.6-0.6-1.4-0.6-2,0C197.3,102.2,197.3,103.1,197.9,103.6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grove_x5F_rechts"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "187.2,48.6 185.6,49.3 185.2,48.3 183.9,48.9 183.1,47.3 186,46     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "200.2,76.6 197.4,77.9 196.7,76.4 198,75.8 197.5,74.8 199,74     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "199,74 197.5,74.7 196.2,75.3 190.7,77.9 190.3,78.1 189.5,78.5 188,79.2 185.7,80.3 183.5,75.6         185.8,74.6 185.2,73.3 186.8,72.6 187.4,73.8 187.4,73.8 188.1,75.4 186.5,76.1 186.5,76.1 186,76.3 186.7,77.9 186.7,77.9         187.3,77.6 187.3,77.6 196.8,73.2 195.7,70.9 195.3,70.1 194.7,68.8 194.7,68.8 193,65.1 192.4,63.8 192.4,63.8 190.7,60.2         190.1,59 188.4,55.2 187.8,53.9 187.4,53.2 186.3,50.9 176.8,55.3 176.3,55.5 177,57.1 177.6,56.8 179.1,56.1 179.8,57.7         180.4,58.9 178.9,59.7 178.9,59.7 178.3,58.4 176,59.5 173.8,54.8 176.1,53.8 176.1,53.7 177.7,53 178.4,52.7 184.3,49.9         185.6,49.3 187.2,48.6 189,52.5 189.3,53.2 189.9,54.5 191.7,58.2 192.3,59.5 193.9,63.1 194.5,64.4 196.3,68.1 196.9,69.4         197.2,70.2     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "177.2,52 177.7,53 176.1,53.7 176.1,53.8 173.8,54.8 172.6,52.3 174.9,51.2 177.2,50.1 178,51.6     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "191.5,80.7 189.2,81.7 186.9,82.8 185.7,80.3 188,79.2 189.5,78.5 190,79.5 190.8,79.1     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M195.7,70.9l-0.4-0.8l-0.6-1.3v0l-1.7-3.7l-0.6-1.3h0l-1.7-3.6l-0.6-1.3l-1.7-3.7l-0.6-1.3l-0.4-0.8l-1.1-2.3         l-9.5,4.4l-0.5,0.2l0.7,1.5l0.5-0.2l1.5-0.7l0.7,1.5l0.6,1.3v0l0.4,0.8l1.4,2.9v0l0.6,1.3h0l1.7,3.6v0l0.6,1.3v0l1.4,3l0.3,0.8h0         l0.6,1.3v0l0.7,1.5l-1.5,0.7h0l-0.5,0.2l0.7,1.5l0.5-0.2l9.5-4.4L195.7,70.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "185,56.8 183.8,57.4 183.2,56.1 183.4,56 184.2,55.6 184.4,55.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "187.4,61.8 187.2,61.9 187.1,61.9 186.4,62.3 186.4,62.3 186.1,62.4 185.5,61.1 186.8,60.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "189.7,66.7 188.4,67.3 187.8,66 187.8,66 187.8,66 188,65.9 188.8,65.5 188.8,65.5 189,65.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "192,71.7 191.7,71.8 191,72.2 190.7,72.3 190.1,71 191.4,70.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "178.9,59.7 178.9,59.7 178.9,59.7 173.7,62.1 172.6,62.3 172.2,61.5 173.1,60.8 176,59.5 178.3,58.4         178.9,59.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "186.8,72.6 185.2,73.3 184.9,72.5 184.2,71 183.5,69.5 182.9,68.3 181.2,64.7 180.6,63.4 180.6,63.4         179.9,61.9 179.2,60.4 178.9,59.7 178.9,59.7 180.4,58.9 180.8,59.7 180.8,59.7 182.2,62.7 182.7,63.9 182.7,64 184.4,67.5         184.4,67.6 185,68.8 185,68.8 186.4,71.8     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "179.2,65.6 176.1,67.1 174.9,67.3 174.6,66.5 175.5,65.8 178.6,64.3     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "184.2,71 182.1,71.9 181.4,70.5 180.8,69.2 179.2,65.6 178.6,64.3 177.9,62.9 179.9,61.9 180.6,63.4         180.6,63.4 181.2,64.7 182.9,68.3 183.5,69.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "181.4,70.5 178.4,71.9 177.2,72.2 176.8,71.4 177.7,70.7 180.8,69.2     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "185.8,74.6 183.5,75.6 180.7,77 179.5,77.2 179.2,76.4 180.1,75.7 185.2,73.3     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "183.1,47.3 183.9,48.9 185.2,48.3 185.6,49.3 177.7,53 177.2,52 178,51.6 177.2,50.1     "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "197.5,74.8 198,75.8 196.7,76.4 197.4,77.9 191.5,80.7 190.8,79.1 190,79.5 189.5,78.5 190.3,78.1         190.7,77.9 196.2,75.3 197.5,74.7     "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grove_x5F_links_00000016053385867061381090000005071653326402074504_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "56.4,48.9 57.9,49.6 58.4,48.6 59.7,49.2 60.4,47.7 57.6,46.3     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "43.3,76.9 46.2,78.2 46.9,76.7 45.6,76.1 46.1,75.1 44.5,74.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "44.5,74.4 46.1,75.1 47.4,75.7 52.8,78.2 53.3,78.4 54,78.8 55.6,79.5 57.9,80.6 60,76 57.7,74.9         58.3,73.6 56.8,72.9 56.2,74.2 56.2,74.2 55.5,75.7 57,76.4 57,76.4 57.5,76.7 56.8,78.2 56.8,78.2 56.3,78 56.3,78 46.8,73.5         47.9,71.2 48.2,70.4 48.8,69.2 48.8,69.2 50.6,65.4 51.2,64.2 51.2,64.2 52.8,60.6 53.4,59.3 55.2,55.5 55.8,54.3 56.1,53.5         57.2,51.2 66.7,55.6 67.2,55.8 66.5,57.4 66,57.2 64.5,56.4 63.7,58 63.1,59.3 64.7,60 64.7,60 65.3,58.7 67.6,59.8 69.7,55.1         67.4,54.1 67.4,54.1 65.9,53.4 65.1,53 59.2,50.2 57.9,49.6 56.4,48.9 54.6,52.8 54.2,53.5 53.6,54.8 51.9,58.6 51.3,59.8         49.6,63.4 49,64.7 47.3,68.4 46.7,69.7 46.3,70.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "66.4,52.3 65.9,53.4 67.4,54.1 67.4,54.1 69.7,55.1 70.9,52.6 68.6,51.5 66.3,50.4 65.6,52     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "52.1,81 54.4,82.1 56.7,83.1 57.9,80.6 55.6,79.5 54,78.8 53.6,79.8 52.8,79.5     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M46.8,73.5l9.5,4.4l0.5,0.2l0.7-1.5L57,76.4h0l-1.5-0.7l0.7-1.5v0l0.6-1.3h0l0.3-0.8l1.4-3v0l0.6-1.3v0         l1.7-3.6h0l0.6-1.3v0l1.4-2.9l0.4-0.8v0l0.6-1.3l0.7-1.5l1.5,0.7l0.5,0.2l0.7-1.5l-0.5-0.2l-9.5-4.4l-1.1,2.3l-0.4,0.8l-0.6,1.3         l-1.7,3.7l-0.6,1.3l-1.7,3.6h0l-0.6,1.3l-1.7,3.7v0l-0.6,1.3l-0.4,0.8L46.8,73.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "58.5,57.1 59.8,57.7 60.4,56.4 60.1,56.3 59.4,55.9 59.1,55.8     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "56.2,62.1 56.3,62.2 56.4,62.2 57.2,62.6 57.2,62.6 57.5,62.7 58.1,61.4 56.8,60.8     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "53.9,67 55.2,67.6 55.8,66.3 55.8,66.3 55.8,66.3 55.5,66.2 54.8,65.8 54.8,65.8 54.5,65.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "51.6,72 51.8,72.1 52.6,72.5 52.9,72.6 53.5,71.3 52.2,70.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "64.7,60 64.7,60 64.7,60 69.8,62.4 71,62.6 71.3,61.8 70.4,61.1 67.6,59.8 65.3,58.7 64.7,60     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "56.8,72.9 58.3,73.6 58.7,72.8 59.4,71.3 60.1,69.9 60.7,68.6 62.3,65 62.9,63.7 62.9,63.7         63.6,62.3 64.3,60.7 64.7,60 64.7,60 63.1,59.3 62.8,60 62.8,60 61.4,63 60.8,64.3 60.8,64.3 59.1,67.9 59.1,67.9 58.5,69.1         58.5,69.2 57.2,72.1     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "64.4,65.9 67.5,67.4 68.6,67.6 69,66.8 68.1,66.1 65,64.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "59.4,71.3 61.5,72.3 62.1,70.8 62.7,69.5 64.4,65.9 65,64.7 65.7,63.2 63.6,62.3 62.9,63.7         62.9,63.7 62.3,65 60.7,68.6 60.1,69.9     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "62.1,70.8 65.2,72.3 66.4,72.5 66.7,71.7 65.8,71 62.7,69.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "57.7,74.9 60,76 62.9,77.3 64,77.5 64.4,76.7 63.5,76 58.3,73.6     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.4,47.7 59.7,49.2 58.4,48.6 57.9,49.6 65.9,53.4 66.4,52.3 65.6,52 66.3,50.4     "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "46.1,75.1 45.6,76.1 46.9,76.7 46.2,78.2 52.1,81 52.8,79.5 53.6,79.8 54,78.8 53.3,78.4 52.8,78.2         47.4,75.7 46.1,75.1     "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "RGB-LEDs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RGB-LED"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M108.7,129.8c0,0.3,0.2,0.6,0.6,0.7v1.4c-0.3,0.1-0.6,0.4-0.6,0.7c0,0.3,0.2,0.6,0.6,0.7v0.4             c0,0.2-0.1,0.3-0.3,0.3h-5.7c-0.2,0-0.3-0.1-0.3-0.3v-0.4c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-1.4             c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-0.4c0-0.2,0.1-0.3,0.3-0.3h5.7c0.2,0,0.3,0.1,0.3,0.3v0.4             C108.9,129.2,108.7,129.5,108.7,129.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 128.9,
    className: "st28",
    width: 2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 128.4,
    className: "st29",
    width: 4.1,
    height: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB-LED_00000158739878078468973790000015867953343331084186_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M122.9,129.8c0,0.3,0.2,0.6,0.6,0.7v1.4c-0.3,0.1-0.6,0.4-0.6,0.7c0,0.3,0.2,0.6,0.6,0.7v0.4             c0,0.2-0.1,0.3-0.3,0.3h-5.7c-0.2,0-0.3-0.1-0.3-0.3v-0.4c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-1.4             c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-0.4c0-0.2,0.1-0.3,0.3-0.3h5.7c0.2,0,0.3,0.1,0.3,0.3v0.4             C123.1,129.2,122.9,129.5,122.9,129.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.6,
    y: 128.9,
    className: "st28",
    width: 2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 128.4,
    className: "st29",
    width: 4.1,
    height: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB-LED_00000128446559331746034690000000773108269480224647_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M137,129.8c0,0.3,0.2,0.6,0.6,0.7v1.4c-0.3,0.1-0.6,0.4-0.6,0.7c0,0.3,0.2,0.6,0.6,0.7v0.4             c0,0.2-0.1,0.3-0.3,0.3h-5.7c-0.2,0-0.3-0.1-0.3-0.3v-0.4c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-1.4             c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.6-0.7v-0.4c0-0.2,0.1-0.3,0.3-0.3h5.7c0.2,0,0.3,0.1,0.3,0.3v0.4             C137.3,129.2,137,129.5,137,129.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 128.9,
    className: "st28",
    width: 2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.4,
    y: 128.4,
    className: "st29",
    width: 4.1,
    height: 5.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Kleine_LEDs"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calliope_x5F_3_x5F_Small_x5F_LED",
    width: 1.4,
    height: 2.8,
    id: "XMLID_00000081620067914281799210000005554354341423305093_",
    x: -0.7,
    y: -1.4,
    transform: "matrix(1 0 0 -1 101.5629 26.8604)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calliope_x5F_3_x5F_Small_x5F_LED",
    width: 1.4,
    height: 2.8,
    id: "XMLID_00000042696738688737490220000013228333503857632937_",
    x: -0.7,
    y: -1.4,
    transform: "matrix(1 0 0 -1 98.7249 26.8604)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calliope_x5F_3_x5F_Small_x5F_LED",
    width: 1.4,
    height: 2.8,
    id: "XMLID_00000094584626844950144800000001489643496691546543_",
    x: -0.7,
    y: -1.4,
    transform: "matrix(0 -1 -1 0 205.5136 110.0392)",
    style: {
      overflow: "visible"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.4,54.8L80.4,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H80.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.5,54.8L81.5,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H81.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M82.7,54.8L82.7,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0H83l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H82.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M83.8,54.8L83.8,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H83.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.9,54.8L84.9,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H84.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.1,54.8L86.1,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H86.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.2,54.8L87.2,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H87.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.3,54.8L88.3,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H88.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.5,54.8L89.5,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H89.5z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.6,54.8L90.6,54.8l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0H91l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H90.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,52.1L91.6,52.1l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1V52l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,51L91.6,51L91.5,51l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,49.9L91.6,49.9l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,48.7L91.6,48.7l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,47.6L91.6,47.6l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,46.5L91.6,46.5l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,45.3L91.6,45.3l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,44.2L91.6,44.2l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1V44l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,43.1L91.6,43.1L91.5,43l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.6,41.9L91.6,41.9l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H91.6z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.6,40.9L90.6,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0H91l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H90.6z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.5,40.9L89.5,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H89.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.3,40.9L88.3,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H88.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.2,40.9L87.2,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H87.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.1,40.9L86.1,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H86.1z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.9,40.9L84.9,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H84.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M83.8,40.9L83.8,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H83.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M82.7,40.9L82.7,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0H83l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H82.7z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.5,40.9L81.5,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H81.5z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.4,40.9L80.4,40.9l-0.1-0.1l0-0.1l0-0.1v-2l0-0.1l0-0.1l0.1,0l0.1,0h0.4l0.1,0l0.1,0l0,0.1l0,0.1v2l0,0.1     l0,0.1l-0.1,0l-0.1,0H80.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,41.9L77.8,41.9l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,43.1L77.8,43.1L77.6,43l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,44.2L77.8,44.2l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1V44l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,45.3L77.8,45.3l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,46.5L77.8,46.5l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,47.6L77.8,47.6l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,48.7L77.8,48.7l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,49.9L77.8,49.9l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,51L77.8,51L77.6,51l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1v0.4l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.8,52.1L77.8,52.1l-0.1-0.1l0-0.1l0-0.1v-0.4l0-0.1l0-0.1l0.1,0l0.1,0h2l0.1,0l0.1,0l0,0.1l0,0.1V52l0,0.1     l0,0.1l-0.1,0l-0.1,0H77.8z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "USB-C_Vorne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loetpads"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.9,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.3,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.6,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.1,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.7,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.3,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.9,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 40.7,
    className: "st30",
    width: 0.6,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Bruecke_x5F_unten_x5F_links",
    x: 105.1,
    y: 38.4,
    className: "st19",
    width: 3.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Br\\xFCcke_x5F_unten_x5F_rechts",
    x: 134.1,
    y: 38.4,
    className: "st19",
    width: 3.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "USB",
    className: "st17",
    d: "M134.1,22.3v4.2c0,0,0,0,0,0v14.2h-4.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1         c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.3-0.2-0.5v-1.6c0-0.2-0.2-0.4-0.4-0.4h-3.4         c-0.2,0-0.4,0.2-0.4,0.4v0.2c0,0.1,0,0.2,0.1,0.3v0l0,0l0.1,0.1l0.2,0h0.7v1.8h-8.3V39h0.7c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0.1-0.1         c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1v-0.2c0-0.2-0.2-0.4-0.4-0.4h-3.4c-0.2,0-0.4,0.2-0.4,0.4v1.6c0,0.2,0,0.3-0.2,0.5         c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0h-4.6V26.5c0,0,0,0,0,0         v-4.2h21.7c1.8,0,3.2,0,3.2,0H134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bruecke_x5F_oben_x5F_links",
    className: "st19",
    d: "M137.8,26.5v1h-0.7c-0.2,0-0.4,0.2-0.4,0.4v0.6c0,0.2,0.2,0.4,0.4,0.4h0.7v1         h-3.7v-3.4H137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bruecke_x5F_oben_x5F_links_00000046317777153269327780000000551385265532689583_",
    className: "st19",
    d: "M108.8,26.5v3.4h-3.7         v-1h0.7c0.2,0,0.4-0.2,0.4-0.4V28c0-0.2-0.2-0.4-0.4-0.4h-0.7v-1H108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.1,35.6v0.9c0,0.2-0.1,0.3-0.3,0.3H115c-0.2,0-0.3-0.1-0.3-0.3v-0.9c0-0.2,0.1-0.3,0.3-0.3h2.9         C118,35.3,118.1,35.4,118.1,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M128.2,35.6v0.8c0,0.2-0.1,0.3-0.3,0.3H125c-0.2,0-0.3-0.1-0.3-0.3v-0.8c0-0.2,0.1-0.3,0.3-0.3h2.9         C128.1,35.3,128.2,35.4,128.2,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M129.5,40.7h-4V39h-0.7l-0.2,0l-0.1-0.1l0,0v0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.2c0-0.2,0.2-0.4,0.4-0.4h3.4         c0.2,0,0.4,0.2,0.4,0.4v1.6c0,0.2,0,0.3,0.2,0.5c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2,0.1         C129.4,40.7,129.5,40.7,129.5,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M118.4,38.3v0.2c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1h-0.7v1.8h-4         c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.3,0.2-0.5v-1.6         c0-0.2,0.2-0.4,0.4-0.4h3.4C118.2,37.9,118.4,38.1,118.4,38.3z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Reset-Taste"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M145.4,24.4L145.4,24.4L145.4,24.4l-3.3,3.3l-0.1,0.1l-0.1,0l0,0v-2.8c0-0.3,0.2-0.6,0.6-0.6H145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M151.1,32.9v2.8c0,0.3-0.3,0.6-0.6,0.6h-2.8l0,0h0l0-0.1L151.1,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M151.1,24.9v2.8l-3.4-3.4h2.8C150.8,24.4,151.1,24.6,151.1,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M145.4,36.3h-2.8c-0.3,0-0.6-0.2-0.6-0.6v-2.8l0,0l0.1,0.1l0.1,0.1L145.4,36.3L145.4,36.3L145.4,36.3             L145.4,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M147.7,24.4h-2.3l0,0l-0.1,0.1l-3.2,3.2l-0.1,0.1l-0.1,0l0,0v5.1l0,0l0.1,0.1l0.1,0.1l3.2,3.2l0.1,0.1h0l0,0             h2.3l0,0h0l0-0.1l3.3-3.3v-5.1L147.7,24.4z M150,31.5c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4v-2.3c0-1.9,1.5-3.4,3.4-3.4             s3.4,1.5,3.4,3.4V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M150,29.2v2.3c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4v-2.3c0-1.9,1.5-3.4,3.4-3.4S150,27.3,150,29.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Loetpads_00000043420228105706981810000009200446934696239295_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M144.4,36.3v0.6c0,0.1-0.1,0.1-0.1,0.1h-1.6c-0.1,0-0.1-0.1-0.1-0.1v-0.6H144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M150.5,36.3v0.6c0,0.1-0.1,0.1-0.1,0.1h-1.6c-0.1,0-0.1-0.1-0.1-0.1v-0.6H150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M150.5,23.8v0.6h-1.8v-0.6c0-0.1,0.1-0.1,0.1-0.1h1.6C150.4,23.7,150.5,23.7,150.5,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M144.4,23.8v0.6h-1.8v-0.6c0-0.1,0.1-0.1,0.1-0.1h1.6C144.4,23.7,144.4,23.7,144.4,23.8z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Oscillator_x5F_Interface"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67,34v8c0,0.4-0.3,0.7-0.7,0.7h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-8c0-0.4,0.3-0.7,0.7-0.7h5.7         C66.7,33.3,67,33.6,67,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M66.9,34.1v7.8c0,0.4-0.3,0.7-0.7,0.7h-5.6c-0.4,0-0.7-0.3-0.7-0.7v-7.8c0-0.4,0.3-0.7,0.7-0.7h5.6         C66.6,33.4,66.9,33.7,66.9,34.1z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.6,136.6v3.4h-4v-3.4H81.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M75.4,136.6v3.4h-4v-3.4H75.4z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M75.4,141.5v3.4h-4v-3.4H75.4z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.6,141.5v3.4h-4v-3.4H81.6z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Oscillator_x5F_Interface_00000142174677229098753570000000672237598536849289_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.6,144.2h-8c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h8c0.4,0,0.7,0.3,0.7,0.7v5.7         C81.2,143.9,80.9,144.2,80.6,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M80.5,144.1h-7.8c-0.4,0-0.7-0.3-0.7-0.7v-5.6c0-0.4,0.3-0.7,0.7-0.7h7.8c0.4,0,0.7,0.3,0.7,0.7v5.6         C81.1,143.8,80.8,144.1,80.5,144.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Batterie"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "189.4,131.6 188.5,132.8 188.3,132.6 188.1,132.4 187.9,132.3 187.6,132 187.4,131.9 187.4,131.9         187.2,131.8 187.2,131.7 183.6,129 183.6,128.9 183.6,128.9 183.6,128.9 183.6,128.9 182.9,128 182.9,128 183.4,127.4 183.4,127.4         184.5,127.8 184.5,127.8 184.5,127.8 187.7,130.4 188,130.6 188.1,130.6 188.2,130.7 188.2,130.8 188.3,130.8 188.5,130.9         188.7,131.2 188.9,131.3 189.2,131.5     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "185.9,136.1 185,137.2 184.9,137.1 184.6,136.9 184.4,136.7 184.1,136.5 183.9,136.4 183.7,136.2         183.7,136.2 180.1,133.4 180.1,133.4 180.1,133.4 180.1,133.4 179.4,132.5 179.4,132.5 179.9,131.8 179.9,131.8 181,132.3         181,132.3 184.6,135.1 184.6,135.1 184.7,135.2 184.7,135.2 184.8,135.2 185,135.4 185.3,135.6 185.5,135.8 185.7,136     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "188.8,140.4 188.8,140.4 187.9,141.6 186.6,140.5 185.8,141.6 183.2,139.6 184,138.5 184.9,137.3         187.5,139.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "194.3,133.4 193.4,134.6 192,133.5 189.5,131.5 190.4,130.4 191.2,129.3 193.8,131.3 193,132.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "181.7,141.5 180.3,143.3 176.7,140.5 178.1,138.7     "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 122.8,
    transform: "matrix(0.6133 -0.7898 0.7898 0.6133 -24.7272 199.7108)",
    className: "st21",
    width: 2.3,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "206.6,137.2 205.9,138.1 204.9,139.4 204.6,139.8 203.8,140.8 201.1,144.2 200.1,145.6 197.4,149         196.6,150 196.3,150.4 195.3,151.7 194.6,152.6 194.4,152.5 194.1,152.3 192.8,151.2 192.8,151.2 191.9,152.3 187,148.5         181.6,144.3 180.3,143.3 181.7,141.5 183.2,139.6 185.8,141.6 187.1,142.6 192.1,146.6 193,145.5 193.9,144.3 191.7,142.6         188.8,140.4 187.5,139.4 184.9,137.3 185,137.2 185.9,136.1 188.5,132.8 189.4,131.6 189.5,131.5 192,133.5 193.4,134.6         198.4,138.5 199.3,137.3 200.2,136.3 195.1,132.4 193.8,131.3 191.2,129.3 192.7,127.4 194.1,125.6 195.4,126.6 200.8,130.9         205.7,134.7 204.8,135.8 204.8,135.8 206.2,136.9 206.5,137.1     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "200.2,136.3 199.3,137.3 198.4,138.5 193.4,134.6 193.4,134.6 194.3,133.4 193,132.4 193.8,131.3         195.1,132.4     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "193.9,144.3 193,145.5 192.1,146.6 187.1,142.6 185.8,141.6 186.6,140.5 187.9,141.6 188.8,140.4         191.7,142.6     "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 88.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.5633 62.457)",
    className: "st34",
    width: 8.1,
    height: 9.4
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Taste_A"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "48.3,106.8 46.9,108.2 45.9,107.1 45.9,107.1 45.8,107.1 45.7,106.9 45.4,106.7 45.3,106.6         45.2,106.5 45,106.3 44.8,106.1 43.9,105.2 45.3,103.8 46.5,104.9 46.6,105.1 46.7,105.2 46.8,105.3 47.1,105.5 47.3,105.7         47.5,105.9     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "33.3,91.7 31.9,93.1 31,92.2 30.7,92 30.5,91.8 30.5,91.7 30.3,91.6 30.1,91.4 30,91.2 28.9,90.1         30.3,88.7 31.1,89.6 31.3,89.8 31.5,90 31.7,90.2 31.9,90.3 31.9,90.4 32.1,90.6     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "42.3,82.7 40.9,84.1 40,83.2 39.7,83 39.5,82.8 39.5,82.7 39.4,82.6 38.9,82.1 38.9,82.1 38.7,82         37.9,81.1 39.3,79.7 40.4,80.8 40.5,80.9 40.7,81.2 40.9,81.3 41,81.4 41.1,81.6 41.4,81.8     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "57.3,97.7 55.9,99.1 54.9,98.1 54.9,98.1 54.8,98 54.2,97.5 54.1,97.3 53.8,97 52.9,96.1 54.3,94.7         55.5,95.9 55.7,96.1 55.7,96.1 55.9,96.3 56.1,96.5 56.2,96.6     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M46.6,97.4c-1.9,1.9-5.1,1.9-7,0c-1.9-1.9-1.9-5.1,0-7c1.9-1.9,5.1-1.9,7,0C48.5,92.4,48.5,95.5,46.6,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54.6,93.4l-11-11c-0.3-0.3-0.7-0.3-1,0l-0.3,0.3l-1.4,1.4l-7.6,7.6l-1.4,1.4l-0.3,0.3c-0.3,0.3-0.3,0.7,0,1         l11,11c0.3,0.3,0.7,0.3,1,0l0.3-0.3l1.4-1.4l7.6-7.6l1.4-1.4l0.3-0.3C54.9,94.2,54.9,93.7,54.6,93.4z M42.1,84.3         c0.6-0.5,1.4-0.5,2,0c0.6,0.6,0.6,1.5,0,2c-0.6,0.6-1.4,0.6-2,0C41.5,85.7,41.5,84.8,42.1,84.3z M35.4,94.9c-0.5,0.6-1.4,0.6-2,0         c-0.5-0.6-0.5-1.4,0-2c0.6-0.6,1.5-0.6,2,0C36,93.5,36,94.4,35.4,94.9z M44.1,103.6c-0.6,0.6-1.4,0.6-2,0s-0.6-1.4,0-2         c0.6-0.6,1.4-0.6,2,0C44.7,102.2,44.7,103.1,44.1,103.6z M46.6,97.4c-1.9,1.9-5.1,1.9-7,0c-1.9-1.9-1.9-5.1,0-7         c1.9-1.9,5.1-1.9,7,0C48.5,92.4,48.5,95.5,46.6,97.4z M52.8,94.9c-0.6,0.6-1.4,0.6-2,0c-0.6-0.6-0.6-1.4,0-2c0.6-0.6,1.4-0.6,2,0         C53.3,93.5,53.3,94.4,52.8,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,94.9c-0.6,0.6-1.4,0.6-2,0c-0.6-0.6-0.6-1.4,0-2c0.6-0.6,1.4-0.6,2,0C53.3,93.5,53.3,94.4,52.8,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,86.3c-0.6,0.6-1.4,0.6-2,0c-0.6-0.5-0.6-1.4,0-2c0.6-0.5,1.4-0.5,2,0C44.7,84.8,44.7,85.7,44.1,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4,94.9c-0.5,0.6-1.4,0.6-2,0c-0.5-0.6-0.5-1.4,0-2c0.6-0.6,1.5-0.6,2,0C36,93.5,36,94.4,35.4,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,103.6c-0.6,0.6-1.4,0.6-2,0s-0.6-1.4,0-2c0.6-0.6,1.4-0.6,2,0C44.7,102.2,44.7,103.1,44.1,103.6z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Interface-Prozessor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_DSOLID_00000006705810440971750700000014439073067158281859_",
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M88,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C87.9,53.5,88,53.7,88,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M82.9,53.8v0.9h-0.7v-0.9c0-0.2,0.2-0.3,0.3-0.3C82.7,53.5,82.9,53.7,82.9,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,52.6c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,52.2,79,52.4,79,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,51.3c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,50.9,79,51.1,79,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,50c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,49.7,79,49.8,79,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,48.7c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,48.4,79,48.5,79,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,47.4c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.7h0.9C78.9,47.1,79,47.2,79,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,46.1c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.7h0.9C78.9,45.8,79,45.9,79,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,44.8c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,44.5,79,44.7,79,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,43.5c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,43.2,79,43.4,79,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,42.3c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.6h0.9C78.9,41.9,79,42.1,79,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79,41c0,0.2-0.1,0.3-0.3,0.3h-0.9v-0.7h0.9C78.9,40.6,79,40.8,79,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M82.9,38.8v0.9c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M88,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M91.9,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3S91.9,53.7,91.9,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M90.6,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C90.4,53.5,90.6,53.7,90.6,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M89.3,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C89.2,53.5,89.3,53.7,89.3,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M86.7,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C86.6,53.5,86.7,53.7,86.7,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M85.4,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C85.3,53.5,85.4,53.7,85.4,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M84.1,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3S84.1,53.7,84.1,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M81.6,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3C81.4,53.5,81.6,53.7,81.6,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M80.3,53.8v0.9h-0.6v-0.9c0-0.2,0.1-0.3,0.3-0.3S80.3,53.7,80.3,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M80.3,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3s-0.3-0.1-0.3-0.3v-0.9H80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M81.6,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,50.9v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,49.7v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M84.1,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3s-0.3-0.1-0.3-0.3v-0.9H84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,48.4V49h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M85.4,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,47.1v0.7h-0.9c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M86.7,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,45.8v0.7h-0.9c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,44.5v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M89.3,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,43.2v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3s0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M90.6,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-0.9H90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,41.9v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M91.9,38.8v0.9c0,0.2-0.1,0.3-0.3,0.3s-0.3-0.1-0.3-0.3v-0.9H91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,40.6v0.7h-0.9c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,52.2v0.6h-0.9c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H93.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LED-Matrix",
    transform: "translate(165.2 60.4) scale(0.45 0.437) rotate(90) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LED_0_4",
    x: 10,
    y: 147,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_1_4",
    x: 36,
    y: 147,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_2_4",
    x: 62,
    y: 147,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_3_4",
    x: 88,
    y: 147,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_4_4",
    x: 114,
    y: 147,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_0_3",
    x: 10,
    y: 122,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_1_3",
    x: 36,
    y: 122,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_2_3",
    x: 62,
    y: 122,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_3_3",
    x: 88,
    y: 122,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_4_3",
    x: 114,
    y: 122,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_0_2",
    x: 10,
    y: 97,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_1_2",
    x: 36,
    y: 97,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_2_2",
    x: 62,
    y: 97,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_3_2",
    x: 88,
    y: 97,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_4_2",
    x: 114,
    y: 97,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_0_1",
    x: 10,
    y: 71,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_1_1",
    x: 36,
    y: 71,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_2_1",
    x: 62,
    y: 71,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_3_1",
    x: 88,
    y: 71,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_4_1",
    x: 114,
    y: 71,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_0_0",
    x: 10,
    y: 46,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_1_0",
    x: 36,
    y: 46,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_2_0",
    x: 62,
    y: 46,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_3_0",
    x: 88,
    y: 46,
    className: "ledOn",
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LED_4_0",
    x: 114,
    y: 46,
    className: "ledOn",
    width: 10,
    height: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,40.3v13c0,0.3-0.3,0.6-0.6,0.6h-13c-0.3,0-0.6-0.3-0.6-0.6v-13c0-0.3,0.3-0.6,0.6-0.6h13     C92.6,39.7,92.8,40,92.8,40.3z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M275.6,293.2c-0.5-1.4-1.6-3-4-3c-2.4,0-3.5,1.7-3.9,3.2c-0.4,1.2-1.6,1.7-2.9,1.8c-0.6,0.1-1.3,0.2-2.1,0.3         c3.5,3.1,8.1,5.9,13.1,5.3c2.9-0.4,5.6-1.8,8-4.2c-2.8-0.9-4.6-1.3-5.8-1.4C277,295,276,294.3,275.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M255,298.1c0.3-0.1,0.5-0.2,0.8-0.4c0,0-0.1-0.1-0.1-0.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmV3PlatinePlain);
export default __webpack_public_path__ + "static/media/CM_V3_Platine_plain.639884e5077e1796c8468341230bd1c6.svg";
export { ForwardRef as ReactComponent };